import React, {
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';

import { parseISO } from 'date-fns';
import moment from 'moment';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  clearLicenseReference,
  resetLicenseStep,
  setLicenseStep,
  setLicenseValidity,
} from '../../../actions/dashboardAction';
import CustomProgress from '../../../components/Progress/progress.component';
import {
  formatDate,
  formatMonth,
  formatYear,
} from '../../../constant/momentConstant';
import { SuccessAlert2 } from '../../../helpers/alert.helpers';
import {
  selectDashboardLicense,
} from '../../../selector/dashboard/licenseReferenceSelector';
import { infoAlert } from '../../../utils/infoAlertEmployeeLicence';
import ModalConfirm from './ModalConfirm';
import ModalDialog from './ModalDialog';

const ModalEmployeeLicence = memo(() => {
  moment.locale('es');
  const dispatch = useDispatch();

  const [licenceDate, setLicenceDate] = useState(null);
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const {
    basicPlanAvailability,
    licenseValidity,
    loadingLicenseValidity,
    licenseStep,
  } = useSelector(selectDashboardLicense);

  useEffect(() => {
    if (basicPlanAvailability?.mostrar) {
      dispatch(setLicenseStep(1));
      setMessage(basicPlanAvailability?.mensaje);
      setOpenDialog(true);
    }
  }, [basicPlanAvailability, dispatch]);

  const vigencias = basicPlanAvailability?.vigenciaPlan
    .map(parseISO)
    .sort((a, b) => a - b);

  const [minDate, planPaymentDate, maxDate] = vigencias;

  const formatedMinDate = minDate && moment(minDate).format(formatDate);
  const formatedPlanPaymentDate =
    planPaymentDate && moment(planPaymentDate).format(formatDate);
  const formatedMaxDate = maxDate && moment(maxDate).format(formatDate);

  const handleConfirmDate = useCallback(() => {
    if (!licenceDate) return;

    dispatch(setLicenseStep(2));
    setOpenConfirm(true);
  }, [licenceDate, dispatch]);

  useEffect(() => {
    if (licenseStep === 3) {
      dispatch(clearLicenseReference());
      dispatch(resetLicenseStep());
    }

    if (!licenseValidity?.newEffectiveLicenseDate) return;

    setOpenConfirm(false);
    dispatch(setLicenseStep(3));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licenseValidity, dispatch]);

  const handleSetDate = useCallback(() => {
    const month = moment(licenceDate, formatDate).format(formatMonth);
    const year = moment(licenceDate, formatDate).format(formatYear);
    dispatch(setLicenseValidity(month, year));
  }, [licenceDate, dispatch]);

  const handleBackStep = useCallback(() => {
    dispatch(setLicenseStep(licenseStep - 1));
  }, [licenseStep, dispatch]);

  const renderModal = useCallback(() => {
    switch (licenseStep) {
      case 1:
        return !basicPlanAvailability?.mostrar ? (
          <CustomProgress />
        ) : (
          <ModalDialog
            open={openDialog}
            minDate={formatedMinDate}
            date={formatedPlanPaymentDate}
            maxDate={formatedMaxDate}
            setDate={setLicenceDate}
            action={handleConfirmDate}
            message={message}
          />
        );
      case 2:
        return (
          <ModalConfirm
            open={openConfirm}
            textContent={`Estás seguro que deseas establecer el siguiente mes, ${licenceDate}, para el inicio de la vigencia?`}
            actionConfirm={handleSetDate}
            actionCancel={handleBackStep}
            loading={loadingLicenseValidity}
          />
        );
      case 3:
        return licenseValidity?.newEffectiveLicenseDate
          ? SuccessAlert2(infoAlert.title, infoAlert.text)
          : null;
      default:
        return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licenseStep, licenceDate, loadingLicenseValidity]);

  return renderModal();
});

export default ModalEmployeeLicence;
